
  export const nftmarketaddress = "0x5b63adf218d5eb928ff24146670e45217b4af9e6"
  export const nftaddress = "0x6c8b020d4f770c11864485b22987354211f59f3e"
  